
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const OpenBook = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="OpenBook" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M9.883 11.514l4.00037-.99807.24208.97026-4.00038.99807zM16 0v14l-8 2-8-2V0l8 2zM1 13.219l6.5 1.625V2.906L1 1.281zM15 1.281L8.5 2.906v11.938l6.5-1.625zM5.8829 12.485l.24253-.97015-3.9999-1-.24253.97015zm-.00059-2.99811l.243-.97L2.126 7.515l-.243.97zM5.8829 6.485l.24253-.97015-3.9999-1L1.883 5.485zm4.2421 2.999l3.99931-.99777-.242-.97L9.883 8.514zm0-2.999l3.99931-.99777-.242-.97L9.883 5.515z" />
</svg>
    </HvIconBase>
)};

OpenBook.propTypes = HvIconBase.propTypes;

export default OpenBook;